module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ser"
    }
  }, [_c('p', {
    staticClass: "rv"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pi"
    }
  }), _vm._v("“In this volume Bruce Waltke, James Houston, and Erika Moore cover a selection of psalms that strikingly combine sadness and sorrow with faith and hope. . . . Masterful exegesis here blends with luminous theological perspectives and pastoral insights.”")]), _vm._v(" "), _c('p', {
    staticClass: "rvt"
  }, [_vm._v("— J"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" I"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" P"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ACKER")])]), _vm._v(" "), _c('p', {
    staticClass: "rvt"
  }, [_c('i', [_vm._v("Regent College")])]), _vm._v(" "), _c('p', {
    staticClass: "rv"
  }, [_vm._v("“If you plan to preach on these hymns of hurt and confusion, this book is a good place to begin. Each psalm is translated in a helpful way, which is vital for preaching these psalms well.”")]), _vm._v(" "), _c('p', {
    staticClass: "rvt"
  }, [_vm._v("— H"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ADDON")]), _vm._v(" R"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OBINSON")])]), _vm._v(" "), _c('p', {
    staticClass: "rvt"
  }, [_c('i', [_vm._v("Gordon-Conwell Theological Seminary")])]), _vm._v(" "), _c('p', {
    staticClass: "rv"
  }, [_vm._v("“Here is the finest of guides to laments in the book of Psalms. The authors recover a cogent interpretation of personal sin that forms the basis of the need for God’s redemption. The cry of lament begins in the heart of the psalmist — and of his readers — and proceeds to express complete dependence on God. Journey on this ancient path of laments that bring us into God’s presence as no other texts of Scripture do.”")]), _vm._v(" "), _c('p', {
    staticClass: "rvt"
  }, [_vm._v("— R"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ICHARD")]), _vm._v(" S"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" H"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ESS")])]), _vm._v(" "), _c('p', {
    staticClass: "rvt"
  }, [_c('i', [_vm._v("Denver Seminary")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59ed1212","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-psalmschristian-0002.vue
// module id = 57
// module chunks = 0